const firebaseConfig = {
  apiKey: "AIzaSyDj8KG67rvoFQnnAPC4g7O7PyNl47-iVRM",
  authDomain: "grocery-station.firebaseapp.com",
  projectId: "grocery-station",
  storageBucket: "grocery-station.appspot.com",
  messagingSenderId: "158363005391",
  appId: "1:158363005391:web:bd5bae29e275c726a122ba"
};
export default firebaseConfig;